import React from "react";
import Button  from "react-bootstrap/Button";
import { Text } from "react-bootstrap-text";
import { Row, Col ,Container, Card} from "react-bootstrap";
import { LightningCharge, Cash, Sim, Headset } from 'react-bootstrap-icons';

const Home = ( {showAirtimeModal, showTokenModal}) => {

   return (
      <Container>
         <Row>
            <Col sm={4} className="new-line">
               <Text size={"3"}>Buy KPLC Prepaid Tokens and Airtime for all networks</Text>
               <Text light size={"6"}>Easily and Securely purchase Prepaid tokens 
               and Airtime via Realtime Digital Services</Text>
               <div className="new-line-btn">
               <Button onClick={showAirtimeModal} className="cta-btn" variant="rounded-3" size="lg">Buy Airtime</Button>
               <Button onClick={showTokenModal} className="cta-btn" variant="rounded-3" size="lg">Buy KPLC Tokens</Button>
               </div>

            </Col>
            <Col className="home-bg" sm={8}></Col>
         </Row>
         <Row className="text-center new-line">
            <Col sm={3}>
               <Card className="border-0">
                  <Card.Body>
                  <Card.Title className="info-head fw-bold"><LightningCharge /></Card.Title>
                  <Card.Subtitle>Instant</Card.Subtitle>                
                  <Card.Text>
                     <small>Airtime or KPLC Tokens delivered instantly upon payment</small>
                  </Card.Text>
                  </Card.Body>
               </Card>
            </Col>
            <Col sm={3}>
               <Card className="border-0">
                  <Card.Body>
                  <Card.Title className="info-head"><Cash /></Card.Title> 
                  <Card.Subtitle>Free</Card.Subtitle>                 
                  <Card.Text>
                     <small>Pay to Till Number so no extra charges especially for Tokens.</small>
                  </Card.Text>
                  </Card.Body>
               </Card>
            </Col>
            <Col sm={3}>
               <Card className="border-0">
                  <Card.Body>
                  <Card.Title className="info-head"><Sim /></Card.Title>
                  <Card.Subtitle>Token sent by SMS</Card.Subtitle>                
                  <Card.Text>
                     <small>KPLC Tokens displayed as well as sent by SMS</small>
                  </Card.Text>
                  </Card.Body>
               </Card>
            </Col>
            <Col sm={3}>
               <Card className="border-0">
                  <Card.Body>
                  <Card.Title className="info-head"><Headset /></Card.Title>
                  <Card.Subtitle>24/7 Support</Card.Subtitle>                
                  <Card.Text>
                     <small>Call Us on 0711 684 717 in case of any enquiries</small>
                  </Card.Text>
                  </Card.Body>
               </Card>
            </Col>
            
         </Row>
      </Container>
   );
   

}

export default Home;